
<div class="split-screen">
    <div class="slideshow-section">
        <div class="slideshow-container">
            <div class="slide" *ngFor="let slide of slides; let i = index" [class.active]="currentSlideIndex === i">
                <div class="slide-background" [ngStyle]="{'background-image': slide.backgroundImage}"></div>
                <div class="slide-overlay"></div>
                <div class="slide-content">
                    <div class="slide-icon">
                        <i [class]="slide.icon"></i>
                    </div>
                    <h2 class="slide-title">{{ slide.title }}</h2>
                    <p class="slide-description">{{ slide.description }}</p>
                    <div class="slide-tags">
                        <span class="tag" *ngFor="let tag of slide.tags">{{ tag }}</span>
                    </div>
                </div>
            </div>
            <div class="slide-arrow prev-arrow" (click)="changeSlide(-1)">
                <i class="fas fa-chevron-left right-left-icon"></i>
            </div>
            <div class="slide-arrow next-arrow" (click)="changeSlide(1)">
                <i class="fas fa-chevron-right right-left-icon"></i>
            </div>
            <div class="slide-dots">
                <div class="dot" *ngFor="let slide of slides; let i = index" [class.active]="currentSlideIndex === i"
                    (click)="currentSlide(i)"></div>
            </div>
        </div>
    </div>

    <div class="login-section">
        <div class="login-card">
            <div *ngIf="!commonDataObject.isForgot && !commonDataObject.isOTP && !commonDataObject.isVerify">
                <div class="logo-area">
                    <div class="logo-icon">
                        <i class="fas fa-hand-holding-heart login-card-hand-icon"></i>
                    </div>
                    <h1>SRK CSR</h1>
                    <p class="tagline">Empowering Communities, Transforming Lives</p>
                </div>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="input-group">
                        <label class="input-label">Email Address</label>
                        <div class="input-wrapper">
                            <i class="fas fa-envelope input-icon"></i>
                            <input type="email" class="input-field" formControlName="user_login_name"
                                placeholder="Enter your email"
                                [class.error]="loginForm.get('user_login_name')?.invalid && loginForm.get('user_login_name')?.touched">
                        </div>
                        <div class="error-message"
                            *ngIf="loginForm.get('user_login_name')?.invalid && loginForm.get('user_login_name')?.touched">
                            <small *ngIf="loginForm.get('user_login_name')?.errors?.['required']">Email is
                                required</small>
                            <small *ngIf="loginForm.get('user_login_name')?.errors?.['email']">Please enter a valid
                                email</small>
                        </div>
                    </div>
                    <div class="input-group">
                        <label class="input-label">Password</label>
                        <div class="input-wrapper">
                            <i class="fas fa-lock input-icon"></i>
                            <input [type]="showPassword ? 'text' : 'password'" class="input-field"
                                formControlName="password" placeholder="Enter your password"
                                [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                            <i class="fas toggle-password" [class.fa-eye]="!showPassword"
                                [class.fa-eye-slash]="showPassword" (click)="togglePassword()"></i>
                        </div>
                        <div class="error-message"
                            *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                            <small *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</small>
                            <small *ngIf="loginForm.get('password')?.errors?.['minlength']">Password must be at least 6
                                characters</small>
                        </div>
                    </div>

                    <div class="options-row">
                        <a href="javascript:void(0)" class="forgot-link" (click)="forgotPW()">Forgot Password?</a>
                    </div>
                    <button type="submit" class="login-btn" [disabled]="isLoading">
                        <i class="fas fa-sign-in-alt" *ngIf="!isLoading"></i>
                        <span class="loading-spinner" *ngIf="isLoading"></span>
                        {{ isLoading ? 'Logging in...' : 'Login' }}
                    </button>
                </form>
            </div>

            <div *ngIf="commonDataObject.isForgot && !commonDataObject.isOTP && !commonDataObject.isVerify">
                <div class="logo-area">
                    <div class="logo-icon">
                        <i class="fas fa-key"></i>
                    </div>
                    <h1>Forgot Password?</h1>
                    <p class="tagline">Enter your email to receive OTP</p>
                </div>
                <form [formGroup]="loginForm" (ngSubmit)="sendOTP()">
                    <div class="input-group">
                        <label class="input-label">Email Address</label>
                        <div class="input-wrapper">
                            <i class="fas fa-envelope input-icon"></i>
                            <input type="email" class="input-field" formControlName="user_login_name"
                                placeholder="Enter your email"
                                [class.error]="loginForm.get('user_login_name')?.invalid && loginForm.get('user_login_name')?.touched">
                        </div>
                        <div class="error-message"
                            *ngIf="loginForm.get('user_login_name')?.invalid && loginForm.get('user_login_name')?.touched">
                            <small *ngIf="loginForm.get('user_login_name')?.errors?.['required']">Email is
                                required</small>
                            <small *ngIf="loginForm.get('user_login_name')?.errors?.['email']">Please enter a valid
                                email</small>
                        </div>
                    </div>
                    <div class="button-group">
                        <button type="submit" class="login-btn" [disabled]="!loginForm.get('user_login_name')?.value">
                            <i class="fas fa-paper-plane"></i> Send OTP
                        </button>
                        <button type="button" class="back-btn" (click)="backToLogin()">
                            <i class="fas fa-arrow-left"></i> Back to Login
                        </button>
                    </div>
                </form>
            </div>

            <div *ngIf="!commonDataObject.isForgot && !commonDataObject.isVerify && commonDataObject.isOTP">
                <div class="logo-area">
                    <div class="logo-icon">
                        <i class="fas fa-shield-alt"></i>
                    </div>
                    <h1>Verification Code</h1>
                    <p class="tagline">Enter the OTP sent to your email</p>
                </div>

                <form (ngSubmit)="sendOTP('verify')">
                    <div class="input-group">
                        <label class="input-label">Enter OTP</label>
                        <div class="input-wrapper">
                            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                                [config]="{length:6}"></ng-otp-input>
                        </div>
                    </div>

                    <div class="button-group">
                        <button type="submit" class="login-btn" [disabled]="!loginForm.get('otp')?.value">
                            <i class="fas fa-check-circle"></i> Verify OTP
                        </button>
                        <button type="button" class="back-btn" (click)="backToLogin()">
                            <i class="fas fa-arrow-left"></i> Back
                        </button>
                    </div>
                </form>
            </div>

            <div *ngIf="!commonDataObject.isForgot && !commonDataObject.isOTP && commonDataObject.isVerify">
                <div class="logo-area">
                    <div class="logo-icon">
                        <i class="fas fa-lock"></i>
                    </div>
                    <h1>Change Password</h1>
                    <p class="tagline">Create a new secure password</p>
                </div>

                <form [formGroup]="loginForm" (ngSubmit)="sendOTP('password')">
                    <div class="input-group">
                        <label class="input-label">New Password</label>
                        <div class="input-wrapper">
                            <i class="fas fa-lock input-icon"></i>
                            <input [type]="showNewPassword ? 'text' : 'password'" class="input-field"
                                formControlName="password" placeholder="Enter new password" (input)="checkPassword()">
                            <i class="fas toggle-password" [class.fa-eye]="!showNewPassword"
                                [class.fa-eye-slash]="showNewPassword" (click)="showNewPassword = !showNewPassword"></i>
                        </div>
                    </div>

                    <div class="input-group">
                        <label class="input-label">Confirm Password</label>
                        <div class="input-wrapper">
                            <i class="fas fa-check-circle input-icon"></i>
                            <input [type]="showConfirmPassword ? 'text' : 'password'" class="input-field"
                                formControlName="confirm_password" placeholder="Confirm your password"
                                (input)="checkPassword()">
                            <i class="fas toggle-password" [class.fa-eye]="!showConfirmPassword"
                                [class.fa-eye-slash]="showConfirmPassword"
                                (click)="showConfirmPassword = !showConfirmPassword"></i>
                        </div>
                    </div>

                    <div class="error-message text-center"
                        *ngIf="!commonDataObject.isMatch && loginForm.get('confirm_password')?.value">
                        Password and Confirm Password must match.
                    </div>
                    <div class="button-group">
                        <button type="submit" class="login-btn" [disabled]="!commonDataObject.isMatch">
                            <i class="fas fa-save"></i> Reset Password
                        </button>
                        <button type="button" class="back-btn" (click)="backToLogin()">
                            <i class="fas fa-arrow-left"></i> Back to Login
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
    [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
    <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
        [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
    <span>{{ commonDataObject.apiMeassge }}</span>
    <i class="fas fa-times close-alert"
        (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>